<template>
  <div id="card-explodging" class="d-flex flex-column">
    <div class="img-container">
      <img v-if="this.experience.photo_key" :src="this.experience.photo_key" alt="" class="exp-img" @click="openModal" />
      <img v-else src="https://hortense-vue.s3.eu-west-3.amazonaws.com/static/default.jpg" alt="" class="exp-img"/>
    </div>
    <div class="d-flex align-items-end" :class="isPhone ? 'justify-content-start' : ''">
      <div :class="isPhone ? 'phone-info-exp pt-3 pl-3' : 'info-exp'">
        <div class="header d-flex justify-content-between">
            <h3 class="category-exp raleway-bold-p15 mr-2 text-uppercase">{{ this.experience.name }}</h3>
            <div>
                <img src="../../images/wishlistOn.svg" v-set-alt v-if="isIncludeInWishlist()" @click="toggleLike()" />
                <img src="../../images/wishlist.svg" v-set-alt v-else @click="toggleLike()" />
            </div>
        </div>
        <p v-if="!isPhone" class="raleway-reg-p15 mb-1">
          <span v-if="!showMore">
            {{ truncatedText(150) }}
          </span>
          <span v-else>
            {{ this.experience.description }}
          </span>
        </p>
        <button v-if="!isPhone && this.experience.description && this.experience.description.length > 150" @click="toggleText" class="show-more-btn raleway-semi-p15 text-green text-underline pl-0">
          {{ showMore ? 'Voir moins' : 'Voir plus' }}
        </button>
        <p v-if="!isPhone" class="merriweather-reg-15 mt-2 mb-1">Où ?</p>
        <p v-if="!isPhone" class="raleway-reg-p15 address-clickable" @click="showOnMap">{{ this.experience.address }}</p>
      </div>
    </div>
  </div>
</template>
<script>
  import fetcher from 'packs/shared/api.js';

  export default {
    name: 'CardExplodging',
    props: ['experience', 'user'],
    data() {
      return {
        wishlistExp: null,
        showMore: false,
      };
    },
    methods: {
      truncatedText(textLength) {
        const text = this.experience.description;
        const maxLength = textLength;
        if (text.length > maxLength) {
          return text.substring(0, maxLength) + "...";
        }
        return text;
      },
      toggleText() {
      this.showMore = !this.showMore;
      },
      openModal() {
        if (this.isPhone) {
          this.$emit('open-modal', this.experience);
          document.body.style.overflow = 'hidden';
        }
      },
      closeModal() {
        this.$emit('close-modal');
        document.body.style.overflow = 'auto';
      },
      isIncludeInWishlist() {
        if (this.wishlistExp) {
          for (const experience of this.wishlistExp) {
            if (experience.id === this.experience.id) {
              return true;
            }
          }
        }
        return false;
      },
      async toggleLike() {
        try {
          if (Object.entries(this.user).length != 0) {
            const response = await fetcher.patch('/wishlists/' + this.user.id, { experience_id: this.experience.id });
            this.wishlistExp = response.data.experiences;
          } else {
            this.$root.$emit('openModal');
          }
        } catch (e) {
          console.error(e);
        }
      },
      async fetchWishlist() {
        try {
          if (this.user) {
            const response = await fetcher.get('/wishlists.json');
            console.log(response);
            this.wishlistExp = response.data.experiences;
          }
        } catch (e) {
          console.error(e);
        }
      },
      showOnMap() {
        this.$emit('showOnMap', this.experience);
      },
    },
    mounted() {
      this.fetchWishlist();
    },
    computed: {
      isPhone() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return true;
        }else{
        return false;
        }
      },
    }
  };
</script>
<style lang="scss" scope="app/assets/stylesheets/components/lodging-show">
.phone-info-exp {
  background: #fff;
  width:80%;
  margin-top: -4rem;
  margin-left:3.5rem;
  padding:5px;
}

.phone-info-exp h5 {
	text-align: left;
}

.address-clickable {
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }

  @media screen and (max-width: 768px) {
    text-decoration: underline;
  }
}

</style>
<style lang="scss" scope="app/assets/stylesheets/components/lodging-show"></style>


<style lang="scss" scoped >
#card-explodging {
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 768px) {
    width: 70vw;
    padding-right: 20px;
  }

  .img-container {
    img {
      height: 326px;
      width: 100% !important;
      border-radius: 15px;
    }
  }
}

.info-exp {
  text-align: left;
  margin-top: 15px;
}
</style>